import Ratingimg from "../Assets/Rating.png"
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

import { Navigation, Pagination, Scrollbar, A11y, FreeMode, Thumbs, Autoplay } from 'swiper'
import Up from "../Assets/Up.png"
import Down from "../Assets/Down.png"

// Import Swiper styles
import 'swiper/css';
import "swiper/css/navigation";
import "swiper/css/free-mode";
import "swiper/css/thumbs";

import { useEffect, useRef, useState } from 'react';
import ImageContent from '../Utils/ImageContent';
import TestimonialCard from '../Utils/Testimonial';
import YouTube from 'react-youtube'
import { AiOutlineClose } from 'react-icons/ai';
import Back from "../Assets/Back.png";
import Left from "../Assets/Left.png"
import Right from "../Assets/Right.png"
const Rating=()=>
{
function importAll(r) {
    let images = {};
    r.keys().map((item, index) => { images[item.replace('./', '')] = r(item); });
    return images;
    }
      
    
const images = importAll(require.context('../Assets', false, /\.(png|jpe?g|svg|mp4)$/));
const[sliderdata,setsliderdata]=useState([])
const[testimonialdata,settestimonialdata]=useState([])
const [swiper,setSwiper]=useState(null)
const [videourl,setvideourl]=useState("")
const[videoswiper,setvideoswiper]=useState(null)
const[zoomimage,setzoomimage]=useState(false)
const navigationPrevRef=useRef(null)
const navigationNextRef=useRef(null)
const restorevideodefault=()=>
{
    videourl!=""?videoswiper.autoplay.start():videoswiper.autoplay.stop()
    setvideourl("")
}
const testimonials=[
    [
        "JoYMWbrzNsA",
        "Dr. Tanu Dang & Devendra Dang",
        images['Tanu.png']
    ],
    [
        "",
        "Mr. Abhijit Thombre",
        "BRIK itt is an excellent alternative investment platform to diversify your portfolio. I always wanted to have holiday homes in unique locations near to beach, mountains, snow. But making full investment was financial challenge for me and maintenance is another headache. And magically BRIK itt came into my notice and made my dream come true. Now I can have holiday homes in multiple beautiful places where me and my family can visit and enjoy in our leisure time without worrying about maintenance and upkeep of the property."
    ],
    [
        "",
        "Anoop Singh",
        "BRIKitt for me comes as an opportunity to make my DREAM of owing a Holiday Home come true. Thanks to BRIKitt for this brilliant opportunity of pocket friendly investment. I am really satisfied with the efficiency and professionalism shown whilst completing the onboarding. BRIKitt is highly recommended and BRIK is worth including in your investment portfolio."

    ],
    [
        "",
        "Mr. Sanjay Koul",
        "I must say that I was bit worried when I signed up with BRIKitt, but as I dealt with them, I was pleasantly surprised at their speed and professionalism. I am very happy with BRIK itt and would be happy recommending them to my friends."
    ],
    [
        "",
        "Shubha Bisotra",
        "Having been born and brought up in the hill state of Himachal and visiting Kasauli throughout my childhood, I always dreamt of having something to call my own in this beautiful hill station. I am super exited for this novel investment opportunity. Looking forward to using the property soon. All the best to the ever so helpful and enterprising BRIK itt Team." 
    ],
    [
        "XtclwqOGYRY",
        "Ms. Suja Das & Ms. Kuldeep Kaur",
        images['Suja.png']
    ],

    [
        "G8FquTYCDWg",
        "Ms. Liane Ghosh",
        images['Liane.png']
    ],
    [
        "JEJE0pNsI6U",
        "Mr. Gadhvi Aniruddhsinh Kishorsinh",
        images['Gadhvi.png']
    ],
    [
        "PpYJ_-uMCms",
        "Mr. Sulakshana Nagesh Gangolly",
        images['Nagesh.png']
    ],
    
   
    // {
    //     "Amrut Farms":[
            
    //     ]
    // },
    // {
    //     "The Swiss Village":[
    //         [
    //             "JoYMWbrzNsA",
    //             "Dr. Tanu Dang & Devendra Dang",
    //             images['Tanu.png']
    //         ],
    //         [
    //             "",
    //             "Mr. Abhijit Thombre",
    //             "BRIK itt is an excellent alternative investment platform to diversify your portfolio. I always wanted to have holiday homes in unique locations near to beach, mountains, snow. But making full investment was financial challenge for me and maintenance is another headache. And magically BRIK itt came into my notice and made my dream come true. Now I can have holiday homes in multiple beautiful places where me and my family can visit and enjoy in our leisure time without worrying about maintenance and upkeep of the property."
    //         ],
    //         [
    //             "",
    //             "Anoop Singh",
    //             "BRIKitt for me comes as an opportunity to make my DREAM of owing a Holiday Home come true. Thanks to BRIKitt for this brilliant opportunity of pocket friendly investment. I am really satisfied with the efficiency and professionalism shown whilst completing the onboarding. BRIKitt is highly recommended and BRIK is worth including in your investment portfolio."

    //         ],
    //         [
    //             "",
    //             "Mr. Sanjay Koul",
    //             "I must say that I was bit worried when I signed up with BRIKitt, but as I dealt with them, I was pleasantly surprised at their speed and professionalism. I am very happy with BRIK itt and would be happy recommending them to my friends."
    //         ],
    //         [
    //             "",
    //             "Shubha Bisotra",
    //             "Having been born and brought up in the hill state of Himachal and visiting Kasauli throughout my childhood, I always dreamt of having something to call my own in this beautiful hill station. I am super exited for this novel investment opportunity. Looking forward to using the property soon. All the best to the ever so helpful and enterprising BRIK itt Team." 
    //         ]
    //     ]
    // }
]
    return(
        // <div className="flex flex-col justify-center sm:py-[40px] lg:pt-[100px] sm:px-[27px] lg:px-[135px] lg:pb-[135px] ">
        //     <img src={Ratingimg} className="sm:px-[125px] sm:pb-[40px] lg:px-[522px] lg:pb-[15px]"></img>
        //     <p style={{fontFamily:"Playfair Display"}} className="lg:w-[800px] sm:text-[16px] lg:text-[28px] m-auto text-[#263238] font-[400] sm:leading-[42px] lg:leading-[35px] italic sm:text-center lg:text-justify sm:mb-[34px] lg:mb-[22px]">“Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore Lorem ipsum dolor sit amet, consectetur” </p>
        //     <p style={{fontFamily:"Inter"}} className="sm:text-[#858585] lg:text-[#263238] text-[18px] font-[600] leading-[22px] italic text-center">Lorem ipsum Name</p>
        // </div>
        <div className='sm:px-[16px] sm:py-[30px] lg:px-[158px] lg:pt-[60px]'>
            <p style={{fontFamily:"Playfair Display"}} className='text-[#C69130] sm:text-[28px] lg:text-[35px] font-[600] sm:leading-[37px] lg:leading-[56px] tracking-[0.5px] sm:mb-[10px] lg:mb-[0px]'>Customer Testimonials</p>
            <div className='bg-[#FFF8EA] p-[20px] mt-[20px]'>
                <Swiper 
                onSwiper={setvideoswiper}
                modules={[Pagination, Navigation, Autoplay]}
                pagination= {{
                    el: '.swiper-custom-pagination',
                  }}
                direction='horizontal'
                className='swiper2'
                navigation={{
                    prevEl: navigationPrevRef.current,
                    nextEl: navigationNextRef.current,
                  }}
                onBeforeInit={(swiper) => {
                    swiper.params.navigation.prevEl = navigationPrevRef.current;
                    swiper.params.navigation.nextEl = navigationNextRef.current;
               }}
                loop="true"
                autoplay={{
                    delay: 8000,
                    disableOnInteraction: false,
                }}
                >
                    {
                        testimonials?.map((e,i)=>
                        {
                            return(
                                <SwiperSlide className='relative flex flex-col justify-center items-center w-full h-[500px]' key={i}>
                                    <TestimonialCard videourl={videourl} setvideourl={setvideourl} swiper={videoswiper} key={i} url={e[0]} name={e[1]} text={e[2]} />
                                </SwiperSlide>
                            )
                        })
                    }
                    <div className='w-full absolute top-[75%] z-10 flex justify-between'>
                        <div id='activeeffect' className='' ref={navigationPrevRef}><img src={Left}/></div>
                        <div id='activeeffect' className='' ref={navigationNextRef}><img src={Right}/></div>
                    </div>
                    <div className="swiper-custom-pagination"/>
                </Swiper>
                
                {/* {
                    
                    testimonialdata?.map((e,i)=>
                    {
                        
                        return <TestimonialCard key={i} url={e[0]} name={e[1]} text={e[2]} />
                    })
                } */}
                <div style={{display:videourl!=""?"block":"none"}} className='after' >
                    <div id='activeeffect' onClick={restorevideodefault} className="w-full px-[9px] pt-[13px] pb-[30px]">
                                <img src={Back}/>
                    </div>
                    <div className='flex justify-center h-[50%] lg:ml-[0px]'>
                        <div onClick={restorevideodefault} className="w-full"></div>
                        <div className="w-full h-full">
                        <YouTube videoId={videourl} opts={{width:800,height:500,playerVars:{autoplay:1}}} className='video-player'/>
                        </div>
                        {/* <AiOutlineClose className='' size="40px" color='black' style={{cursor:"pointer"}} onClick={()=>{
                            videourl!=""?videoswiper.autoplay.start():videoswiper.autoplay.stop()
                            setvideourl("")
                        } }/> */}
                        <div onClick={restorevideodefault} className="w-full h-full">
                        </div>
                        
                    </div>
                    <div onClick={restorevideodefault} className="w-full h-full">
                    </div>
                </div>
                

            </div>
        </div>
    )
}
export default Rating